import { z } from "zod";
import { regularShiftSchema } from "../../models";

export const createPartTimeFormSchema = z.object({
  firstNameEn: z.string().trim().min(1),
  lastNameEn: z.string().trim().min(1),
  fullNameZhHk: z.string().trim().min(1),
  eid: z.string().trim().length(6),
  countryCode: z.string().min(1),
  phoneNumber: z.string().regex(/^\d+$/), // numeric
  stationId: z.number().int(),
  role: z.number(),
  regularShiftSchedule: z.array(regularShiftSchema),
  stationTeamId: z.number().int().nullish(),
  receiveInviteOnHoliday: z.boolean(),
});

export type CreatePartTimeForm = z.infer<typeof createPartTimeFormSchema>;
